import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import Edit from './Edit';
import Type from './Type';
import Code from './Code';
import Design from './Design';
import Experience from './Experience';

export default function(props) {
  const {path,url} = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/type`} component={Type}/>
      <Route path={`${path}/edit`} component={Edit}/>
      <Route path={`${path}/design`} component={Design}/>
      <Route path={`${path}/code`} component={Code}/>
      <Route path={`${path}/experience`} component={Experience}/>
      <Redirect to={`${url}/edit`}/>
    </Switch>
  );
}